<template>
    <section class='main-contents'>

         <section class="wrap-content glass-app popup-content">
             <header>
                 <AppButton v-bind:visibility="true"
                        left_icon="fa-regular fa-circle-xmark fa-xl" emitType="close"
                        @close="CancelDialog" :width=20 :height=20 :padding="'0px'" />
             </header>
             <div class="body">
                
 
                 <section v-if="!pagination" class="content" :style="{width: width}">
 
                     <AppTable :status="entityResponseStatus" :width="'30'" :noClose="true" :simple="true" 
                     :visibility="true" :show="true" :table_data="entityData" :table_title="propsData.title"
                     @row-clicked="selectRowData"
                     @row-doClicked="selectRowData"
                      @close="null" />
 
                 </section>
                 <section v-else class="content" :style="{width: width}">

                     <AppTablePagination :visibility="true" :show="true" 
                         :final-url="finalUrl" 
                         @row-dClicked="ConfirmDialog"
                         :table_title="propsData.title" @row-clicked="selectRowData" @close="null" class="h-full"
                         :urlString="propsData?.url"/> 
                 </section>
             </div>
             <div class="footer pt-6">
                 <section class="left">
                     <button v-for="item in propsData.buttons" class="p-1 text-[.7em] rounded-md bg-[#006698]" @click="dinamicButton(item)">{{item}}</button>
                 </section>
                 <section class="right flex gap-2">
                     <button class="p-1 text-[.7em] rounded-md bg-[red]"    @click="CancelDialog" >Cancelar</button>
                     <button class="p-1 text-[.7em] rounded-md bg-[#006698]" @click="ConfirmDialog" >Confirmar</button>
                     
                 </section>
             </div>
             <!-- <ConfirmDialog @response="responseConfirm"/> -->
             
         </section>
    </section>
 </template>


<script>
    import AppTable from '@/components/tables/table.vue'
    import AppTablePagination from '@/components/tablePagination/tablePagination.vue'
    import AppButton from '@/components/updated/button.vue'
    import ConfirmDialog from '@/components/dialog/confirmDialog.vue'
    import axios from 'axios'
    // import { mapGetters } from 'vuex'

    export default {
        components: {
            AppTable,
            AppTablePagination,
            AppButton,
            ConfirmDialog
        },
        props: {
            pagination: {
                type: Boolean,
                required: false,
                default: false
            },
            finalUrl: {
                type: String,
                required: false,
                default: ''
            },
            width: {
                type: String,
                required: false,
                default: '10vw'
            },
            closeEvents: {
                type: Boolean,
                required: false,
                default: true
            },
            propsData: {
                type: Object,
                required: true,
                default: () => {
                    return {
                        title: '',
                        buttons: [],
                        url: '',
                        title: 'sem titulo',
                        entity: 'no-entity',
                    }
                }
            },
        },

        data() {
            return {
                baseURl: process.env.VUE_APP_URL_BASE,
                entityData: [],
                entityResponseStatus: '',
                // pagination: true,
                selectedRow: null,
                selectedRowData: null,

            }
        },

        methods: {
            selectRowData(data, doubleClick=false) {
                this.selectedRowData = data

                // console.log('Selected Row Data: -------------', this.selectedRowData);
                

                if(doubleClick){
                    this.ConfirmDialog()
                }
            },



            dinamicButton(item) {
                console.log('Dinamic button acionado!');
            },
            
            CancelDialog() {
                this.$emit('close')
                if(this.closeEvents){
                    this.$emit('closeTrigger')
                }
            },
            
            ConfirmDialog(data = null) {

                // if(data){
                //     this.selectedRowData = data
                // }
                if(data){
                    this.$emit('returnData', { data: this.selectedRowData})
                }else{
                    return
                }
            },

            async fetchEntityData() {
                try{
                    let url = ''
                    if(this.propsData.url){
                        if(this.propsData.url.includes('?')){
                            url = `${this.baseURl}/api/v1/${this.propsData.url}`
                            console.log('Tem query params.....');
                            
                        }else{
                            console.log('Nao tem query params.....');
                            
                            url = `${this.baseURl}/api/v1/${this.propsData.url}/`
                        }
                    }else{
                        url = `${this.baseURl}/api/v1/${this.propsData.entity}/`
                    }

                    const response = await axios.get(url)
                    if(this.propsData?.inResults){
                        this.entityData = response.data.results
                        this.entityResponseStatus = 200
                    }else{
                        this.entityData = response.data.data
                        this.entityResponseStatus = response.status
                    }

                }catch(error){
                    console.log(error)
                    this.entityResponseStatus = error.response.status

                }
            }
        },

        created() {
            this.fetchEntityData()

            console.log('FinalURL in Dialog: ', this.finalUrl);
            

            


        }

    }
        



</script>





 <style scoped>
 .main-contents{
      background-color: var(--bg-pop-up);
      width: 100vw;
      height: 100%;
      min-height: 100dvh;
      position: fixed;
      inset: 0;
      display: flex;
      justify-content: center;
      align-items: flex-start;
      padding-top: 6em;
      z-index: 100000000;
  }
  
  .wrap-content{ 
      position: relative;
      padding: 1em;
      border-radius: .2em;
      color: #fff;
      width: fit-content;
      height: fit-content;  
      min-height: 20em;
      min-width: 30em;
      

      display: flex;
      flex-direction: column;
      justify-content: space-between;


      position: absolute;
      top: 3em;
      left: 50%;
      transform: translateX(-50%);
      /*transform: translate(-50%, -50%);
      cursor: move; */
  }

  .wrap-content header{ 
      display: flex;
      justify-content: flex-end;
      padding: .3em;
      padding-bottom: .5em;
  }

  .body{ 
      display: flex;
      justify-content: space-between;
     
      gap: 1em;
  }

  aside{
      
      min-height: 20em;
      border-radius: .2em;
      font-size: .7em;
      padding-top: 1em;
      color: #fffb;

      display: flex;
      flex-direction: column;
      justify-content: space-between;
  }

  aside ol li{
      cursor: pointer;
      padding: .1em;
      color: #fff9;
      border-radius: .2em;
      padding: .3em;
  }
  aside ol li.active{
      color: #fff;
  }
  
  aside ol li:hover{
      background-color: rgba(0, 0, 0, 0.193);
  }


  .footer{ 
      display: flex;
      justify-content: space-between;
      gap: 1em;
  }

</style>
   